import React, {forwardRef} from 'react';
import {BlogStyle} from '../assets/css/Styles';
import {Container, Row, Col} from 'react-bootstrap';
import EachBlog from './EachBlog';
import MainTitle from './MainTitle';
import ProgrammingImage from '../assets/images/blogImages/programming.jpg';
import ReactImage from '../assets/images/blogImages/intro_to_programming.jpeg';
import ArduinoTutImage from '../assets/images/blogImages/intro_to_arduino.jpg';

export const Blog = forwardRef(({}, ref) => {
  return (
    <Container ref={ref} style={BlogStyle.blogContainer}>
      <MainTitle title='BLOG' />
      <Row xl='3' lg='3' md='2' sm='1' xs='1'
        style={BlogStyle.specificBlog}>
        <Col style={BlogStyle.eachBlogCol}>
          <EachBlog imgSrc={ProgrammingImage}
            blogTitleTxt='Computer Programming'
            blogDate='September 1, 2019'
            blogTxt='Computer Programming is simply the process
                of writing commands (codes)
                for a computer to accomplish a certain task.' />
        </Col>
        <Col style={BlogStyle.eachBlogCol}>
          <EachBlog
            imgSrc={ReactImage}
            blogTitleTxt='Introduction to React'
            blogDate='March 16, 2020'
            blogTxt='Why React? In the old way of developing the web,
                        multiple individual pages were used to render
                        a small change in a single page.' />
        </Col>
        <Col style={BlogStyle.eachBlogCol}>
          <EachBlog
            imgSrc={ArduinoTutImage}
            blogTitleTxt='Introduction to Arduino'
            blogDate='September 1, 2021'
            blogTxt="Arduino is an open-source electronics platform based
                        on easy-to-use hardware and software. It's intended
                         for anyone making interactive project and best for
                         prototyping." />
        </Col>
      </Row>
    </Container>
  );
});
